export default "__VITE_ASSET__C50OAK6g__"